class TemplateFaqArchive {
  private elScope: HTMLElement;

  private el: {
    selectCat: HTMLSelectElement,
    itemsCat: NodeListOf<HTMLElement>,
  }

  constructor(elScope: HTMLElement) {
    this.elScope = elScope;
    this.el = {
      selectCat: this.elScope.querySelector('.js-t-faq-archive__scat') as HTMLSelectElement,
      itemsCat: this.elScope.querySelectorAll('[data-category]'),
    }
  }

  init() {
    const { el } = this;

    el.selectCat
      .addEventListener('change', (e: any) =>
        this.onSelectCatChange(e.target.value, 'category', el.itemsCat));
  }

  private onSelectCatChange(
    value: string,
    dataSet: string,
    elements: NodeListOf<HTMLElement>
  ) {
    const termSelected = value.toLowerCase();
    const forceShow = termSelected === 'all';

    elements.forEach((el) => {
      const termCurrent = el.dataset[dataSet]?.toLowerCase();
      const isHidden = !forceShow && termCurrent !== termSelected;
      el.classList.toggle('is-hidden', isHidden);
    });
  }
}

export default TemplateFaqArchive;
